import { Reveal } from "../Reveal";
import { STATS } from "../../data/content";

export const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-[#131316] py-24 lg:py-36 grain overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <span className="text-[#e85d04] text-xs font-bold tracking-[0.28em] uppercase">
            Why Choose Us
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 max-w-2xl">
            When it matters most, we show up.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-6">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.1}>
              <div
                data-testid={`stat-${i}`}
                className="border-t border-white/15 pt-6 group"
              >
                <p className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight transition-colors duration-300 group-hover:text-[#e85d04]">
                  {s.value}
                </p>
                <p className="mt-4 text-xs sm:text-sm font-semibold tracking-[0.18em] uppercase text-white/50">
                  {s.label}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
